export default __webpack_public_path__ + "static/media/default.1c629057.jpg";